import React, { useState } from 'react';
import { IonAlert, IonButton, IonIcon } from '@ionic/react';
import { deleteAccount } from '../store/actions/authentication';
import { connect } from 'react-redux';
import { trashOutline } from 'ionicons/icons';
import { AuthenticationRootState } from '../store/reducers/authentication';

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  deleteAccount: (password: string, isRopc: boolean) =>
    dispatch(deleteAccount(password, isRopc))
});

const mapStateToProps = (
  state: {
    authentication: AuthenticationRootState;
  },
  ownProps: any
) => {
  return {
    isRopc: state.authentication.isRopc
  };
};

const LogoutBtn: React.FC<
  ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>
> = ({ deleteAccount, isRopc }) => {
  const [showAlert, setShowAlert] = useState(false);

  function onSubmitPassword(password: string) {
    deleteAccount(password, isRopc);
  }

  return (
    <>
      <IonButton fill="clear" onClick={() => setShowAlert(true)}>
        <IonIcon icon={trashOutline} slot="start"></IonIcon>
        Supprimer mon compte
      </IonButton>
      <IonAlert
        isOpen={showAlert}
        onDidDismiss={() => setShowAlert(false)}
        cssClass="my-custom-class"
        header={
          'Veuillez entrer votre mot de passe pour confirmer la suppression de votre compte.'
        }
        inputs={[
          {
            name: 'password',
            type: 'password',
            placeholder: 'Mot de passe',
            attributes: {
              autoFocus: true
            }
          }
        ]}
        buttons={[
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary'
          },
          {
            text: 'Ok',
            handler: (inputs) => {
              onSubmitPassword(inputs.password);
            }
          }
        ]}
      />
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutBtn);
